import FetchWrapper from "@/components/UI/FetchWraper";
import WorldMap from "@/components/UI/SitesMap/WorldMap";
import { SiteInfo } from "@/components/UI/SitesMap/types";
import { useRef } from "react";
import { useTableHeight as useMapHeight } from "@/utils/tableHelpers";

type MapTabProps = {
  data?: SiteInfo[];
};

const fullSitesPayload = {
  dataset_type: "sites-overview",
  global_filters: [],
  pagination: { page: 1, page_size: 10000 },
};

export function MapTab({ data = [] }: MapTabProps) {
  const subsetSitesData = Array.isArray(data) ? data : [];
  const mapRef = useRef<HTMLDivElement>(null);
  const { tableHeight: mapHeight } = useMapHeight({ tableRef: mapRef });
  const resolvedMapHeight = Math.max(350, mapHeight);

  return (
    <div ref={mapRef}>
      <FetchWrapper
        endpointSuffix="filters/data/"
        method="POST"
        body={fullSitesPayload}
      >
        {(fullSitesResponse) => (
          <WorldMap
            mapHeight={resolvedMapHeight}
            fullSitesData={
              Array.isArray(fullSitesResponse?.results)
                ? fullSitesResponse.results
                : []
            }
            subsetSitesData={subsetSitesData}
          />
        )}
      </FetchWrapper>
    </div>
  );
}
